/**
 * Checks if current index is the last in the looping array.
 * @param {Number} bodyIndex Current body index in array.
 * @param {Array} bodyElements Array of elements.
 * @returns {Boolean}
 */
const isLastIndexOfArray = ({ bodyIndex, bodyElements }) => {
  const lastIndex = bodyElements.length - 1;
  return bodyIndex === lastIndex;
};

export default isLastIndexOfArray;
